<template>
  <v-menu transition="scroll-y-transition" offset-y>
    <template v-slot:activator="{ on, attrs }">
      <v-btn block v-bind="attrs" v-on="on">
        <v-icon class="pr-1"> mdi-web </v-icon>
        <span>{{ $i18n.locale.toUpperCase() }}</span>
      </v-btn>
    </template>
    <v-list>
      <v-list-item class="justify-center"
        v-for="localeItem in $options.locales"
        :key="localeItem.value"
        @click="chooseLocaleHanlder(localeItem.value)"
      >
        {{ localeItem.title }}
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
// HARDCODE
import locales from '@/configs/locales.js'
export default {
  name: 'LanguagePopover',
  locales,
  methods: {
    chooseLocaleHanlder (language) {
      this.$i18n.locale = language
    }
  }
}
</script>
